/**
 * Case list loading policy — first batch for fast paint, remainder in background.
 */

/** First paint on All Cases (3 pages at default page size 20). */
export const FIRST_BATCH = 60;

/** Dashboard default timeline preset key (matches Dashboard PRESETS). */
export const DASHBOARD_DEFAULT_PRESET = 'year';

/** Start of the current calendar year (local midnight). */
export function currentYearStartDate() {
  const now = new Date();
  return new Date(now.getFullYear(), 0, 1, 0, 0, 0, 0);
}

function isoDateLocal(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Lower bound for the dashboard summary fetch — start of this year. */
export function dashboardSinceIso() {
  return isoDateLocal(currentYearStartDate());
}

/** Default dashboard timeline brush window — 1 Jan through today. */
export function defaultDashboardRange() {
  const end = new Date();
  end.setHours(23, 59, 59, 999);
  return { start: currentYearStartDate(), end };
}
